module.exports = __webpack_public_path__ + "static/img/setup_step05@2x.f2a1121.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactUs/establishmentProcess/setup_step05@2x.png
// module id = EXUI
// module chunks = 0